import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LeadsService } from 'src/app/_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MemberService } from 'src/app/_service/member.service';
declare var $: any;
@Component({
  selector: 'app-add-edit-plan-lead',
  templateUrl: './add-edit-plan-lead.component.html',
  styleUrls: ['./add-edit-plan-lead.component.css']
})
export class AddEditPlanLeadComponent implements OnInit {
  planLeadForm: FormGroup; submitted = false; loading: boolean = false; plan_lead_id: any = ''; package_type = [];
  leadStatus = []; leadStatus_copy = [];dataLoaded:boolean=false;
  constructor(private memberapi: MemberService, public router: Router, private formBuilder: FormBuilder, private sharedapi: SharedService, public dialogRef: MatDialogRef<AddEditPlanLeadComponent>, @Inject(MAT_DIALOG_DATA) public data: MatDialog, public leadapi: LeadsService) {

    this.planLeadForm = this.formBuilder.group({
      'name': [null],
      'mobile': [null],
      'circle_name': [null],
      'city': [null],
      'lead_source': [null],
      'package_type_id': [null],
      'lead_status_id': [null],
      'description': [null]
    });

    if (data) {
      this.plan_lead_id = data;
      this.patchPlanLeadData(this.plan_lead_id);
    }
  }

  async updatePlan() {
    this.submitted = true;
    this.loading = true;
    if (this.planLeadForm.invalid) {
      this.loading = false;
      return;
    }
    this.planLeadForm.value.id = parseInt(this.plan_lead_id);
    await this.leadapi.updatePlanLead(this.planLeadForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigate(['/plan-lead-list'])
          .then(() => {
            window.location.reload();
          });
        this.CloseModal();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  ngOnInit(): void {
    this.getleadStatus();
    this.getPackageType();
  }

  async getleadStatus() {
    await this.leadapi.getLeadStatus().subscribe((data: any) => {
      if (data.status) {
        this.leadStatus = data.data;
        this.leadStatus_copy = this.leadStatus;
      } else {
        this.leadStatus = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }
  async getPackageType() {
    await this.memberapi.getPackageType().subscribe((data: any) => {
      if (data.status) {
        this.package_type = data.data;
      } else {
        this.package_type = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type) {
    if (type == 'lead_status') {
      $("#lead_status_Search").val('');
      $("#lead_status_Search").focus();
      this.leadStatus = this.leadStatus_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'lead_status') {
      this.leadStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
    }
  }

  async patchPlanLeadData(plan_lead_id) {
    this.dataLoaded = false;
    await this.leadapi.getplanEditData(this.plan_lead_id).subscribe((response: any) => {
      if (response.status) {
        this.dataLoaded = true;
        this.planLeadForm.patchValue({
          'name': response.data.name,
          'mobile': response.data.mobile,
          'circle_name': response.data.circle_name,
          'city': response.data.cityName,
          'lead_source': response.data.sourceName,
          'package_type_id': response.data.plan_package_id,
          'lead_status_id': response.data.lead_status_id,
          'description': response.data.description

        });
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

}
